import { environment } from '../../../environments/environment';

/**
 * Formats the version shown to users: "v1.3.0", or "v1.3.0-rc.1" when the build has a release candidate number.
 */
export function formatAppVersion(version: string, rc: string | number | null | undefined): string {
  const candidate = Number(rc);

  return candidate > 0 ? `v${version}-rc.${candidate}` : `v${version}`;
}

/**
 * Version of the current build, read from the active environment file.
 */
export function getAppVersion(): string {
  return formatAppVersion(environment.version, environment.rc);
}
